import React, { FunctionComponent } from 'react';
import { Flex } from '@rebass/emotion';
import { css, SerializedStyles } from '@emotion/core';
import theme from '@app/styles/theme';
import ErrorBoundary from '@app/components/ErrorBoundary';

import { ShopStoreProvider } from '@app/shop/context/ShopStoreContext';
import { CartProvider } from '@app/shop/context/CartContext';

import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

const wrapper: SerializedStyles = css`
  background-color: ${theme.colors.white};
  flex: 1;
`;

const PricingLayout: FunctionComponent = ({ children }) => (
  <Flex flexDirection="column" height="100vh">
    <div css={wrapper}>
      <Header />
      <ErrorBoundary>
        <ShopStoreProvider>
          <CartProvider>{children}</CartProvider>
        </ShopStoreProvider>
      </ErrorBoundary>
    </div>
    <Footer />
  </Flex>
);

export default PricingLayout;
